module.exports = __webpack_public_path__ + "static/media/apple-podcasts-logo-sm.08a070c6.png";